/**
 * Device Selector Composable
 * Uses the repair-scoped view of the shared product catalog.
 */
import { apiGet } from '~/utils/api'

export interface DeviceCategory {
  id: string
  code: string
  name: string
  icon: string
  brandId: string
  brandCode: string
  sortOrder: number
}

export interface DeviceModel {
  id: string
  name: string
  modelCode: string
  imageUrl: string | null
  categoryId: string
  categoryCode: string
  sortOrder: number
}

export const useDeviceSelector = () => {
  const loading = ref(false)
  const error = ref<string | null>(null)

  /**
   * 获取设备类别列表（iPhone, iPad, Mac, Watch）
   */
  async function fetchDeviceCategories(): Promise<DeviceCategory[]> {
    loading.value = true
    error.value = null
    try {
      return await apiGet<DeviceCategory[]>('/api/app/v1/repair/device-categories')
    } catch (e: any) {
      error.value = e.message || 'Failed to load device categories'
      return []
    } finally {
      loading.value = false
    }
  }

  /**
   * 获取类别下的设备型号列表
   */
  async function fetchDeviceModels(categoryCode: string): Promise<DeviceModel[]> {
    loading.value = true
    error.value = null
    try {
      return await apiGet<DeviceModel[]>(`/api/app/v1/repair/devices?categoryCode=${encodeURIComponent(categoryCode)}`)
    } catch (e: any) {
      error.value = e.message || 'Failed to load device models'
      return []
    } finally {
      loading.value = false
    }
  }

  return { loading, error, fetchDeviceCategories, fetchDeviceModels }
}
